export default "__VITE_ASSET__56573767__"